export default "__VITE_ASSET__C$1chd1o__"